import { BaseState } from '@bimser/common';
import * as LayoutCreatorEntities from '@bimser/components/dist/BCLayoutCreator/common/entities';
import { Map } from 'immutable';

export function getFormItems(
	state: BaseState,
	windowId: string
): Map<string, LayoutCreatorEntities.LayoutItem> {
	if (state.forms?.count()) {
		const form = state.forms.get(windowId);
		if (form?.items?.entities?.items?.count()) {
			return form.items.entities.items;
		}
	}
}
